import { TimelineAuthor } from '../../../../../../services/Main/types.Component';

function getAuthorAvatarLetters(author: TimelineAuthor) {
  return `${author.lastName[0]}${author.firstName[0]}`;
}

export default getAuthorAvatarLetters;
